import 'what-input';

import React from 'react';

import { Grid } from '$partials/global/index.js';
import { setLocation } from '$utilities/location.js';
import { setUserAgent } from '$utilities/user-agent.js';
import { SkipLink } from '$partials/ui/index.js';
import * as Pages from '$pages/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/app.d.ts').App}
 *
 * Renders the application.
 * 1. If the page component requested doesn’t exist, escapes the function.
 * 2. Skip link are useful for keyboard users to access the main content of the page
 *    straight away without the hassle of navigating through the navigation at each page load.
 * 3. Page component (HomePage, UnionPage, etc.).
 */
const App = props => {
    if (props.location) {
        setLocation(props.location);
    }

    if (props.userAgent) {
        setUserAgent(props.userAgent);
    }

    /* [1] */
    if (!props.pageComponent || typeof (Pages[props.pageComponent]) === 'undefined') {
        return null;
    }

    const Component = Pages[props.pageComponent];
    return (
        <>
            <SkipLink href='#main-content'>Skip to main content</SkipLink> {/* [3] */}
            <SkipLink href='#primary-navigation'>Skip to primary navigation</SkipLink> {/* [3] */}
            <Component {...props} /> {/* [3] */}
            {props.dev && (<Grid isParentHomePage={props.data?.page?.__typename === 'Home'}/>)}
        </>
    );
};

/* ========================================================================= */
/* Typing & export(s) */
/* ========================================================================= */

export { App };
